import type {
  CreateSurveyRequest,
  SurveyFormValues,
  SurveyQuestion,
  SurveyQuestionRequest,
  UpdateSurveyRequest,
} from "../types/survey.types";

export const toSurveyQuestionRequest = ({
  client_id: _clientId,
  ...question
}: SurveyQuestion): SurveyQuestionRequest => question;

export const toSurveyQuestionRequests = (
  questions: SurveyFormValues["questions"],
): SurveyQuestionRequest[] => questions.map(toSurveyQuestionRequest);

export const toCreateSurveyRequest = (formValues: SurveyFormValues): CreateSurveyRequest => ({
  title: formValues.title.trim(),
  description: formValues.description.trim(),
  category: formValues.category,
  points: formValues.points,
  end_time: formValues.endTime?.toISOString() ?? "",
  questions: toSurveyQuestionRequests(formValues.questions),
});

const hasSameTimestamp = (date: Date | undefined, isoDate: string | undefined) => {
  if (!date || !isoDate) {
    return date === undefined && !isoDate;
  }

  const dateTimestamp = date.getTime();
  const originalTimestamp = Date.parse(isoDate);

  return !Number.isNaN(dateTimestamp) && !Number.isNaN(originalTimestamp)
    ? dateTimestamp === originalTimestamp
    : date.toISOString() === isoDate;
};

export const toUpdateSurveyRequest = (
  formValues: SurveyFormValues,
  originalEndTime?: string,
): UpdateSurveyRequest => {
  const request = toCreateSurveyRequest(formValues);

  if (hasSameTimestamp(formValues.endTime, originalEndTime)) {
    const { end_time: _endTime, ...requestWithoutEndTime } = request;
    return requestWithoutEndTime;
  }

  return request;
};
